import styledComponents from 'styled-components'

export const ContainerLink = styledComponents.div`
    &:before {
        left: calc(50% - 15px);
    }
    `
